import React from "react";
import { Link } from "react-router-dom";

export default function GuidanceLink({ to, title, body }) {
  return (
    <Link
      to={to}
      className="w-full flex flex-row items-center gap-3 py-3 text-left hover:underline"
    >
      {/* <span
        className="material-symbols-outlined text-primary text-[24px]"
        aria-hidden="true"
      >
        {icon}
      </span> */}
      <span className="flex-1 min-w-0">
        <span className="subtitle-text block leading-tight">{title}</span>
        <span className="block">{body}</span>
      </span>
      <span
        className="material-symbols-outlined text-primary text-[24px]"
        aria-hidden="true"
      >
        arrow_forward_ios
      </span>
    </Link>
  );
}
